// extracted by mini-css-extract-plugin
module.exports = {"cardOverAll":"applicantquestionnaireresult_cardOverAll__1YE8W","tableDiv":"applicantquestionnaireresult_tableDiv__3oJ8v","svgAngle":"applicantquestionnaireresult_svgAngle__1mDXY"};